import { Injectable } from '@angular/core';
import Dexie from 'dexie';
import { IBidDataFile, pdfFile } from '../models/IBidDataFile';
import { db } from '../utilities/wbid-db';
import { cloneDeep } from 'lodash';
import * as _ from 'lodash';
import { SubmitResult } from '../models/SubmitBidResponseModel';
import { TblBidDataDisplay } from '../models/TblBidDataDisplay';
import moment from 'moment';
import { StateFiles, WBidStateCollection } from '../models/WBidStateCollection';
import { WbidHelper } from './helper';
import { QuickSets } from '../models/QuickSets';
import { FAListData } from '../models/TblFAList';

@Injectable()
export class DexieOperations {
  dbopen = true;
  db: any;
  constructor(public helper: WbidHelper) {
    db.open().then((data) => {
      this.dbopen = true;
    });
  }

  public async getAllDownloadedBid(empnum, callback) {
    db.transaction(
      'rw',
      db._INI,
      db.BidDataDisplay,
      db._Users,
      db.ColumnDefinitions,
      async () => {
        callback(
          await db.BidDataDisplay.where('EmpNum').equals(empnum).toArray()
        );
      }
    );
  }

  /**
   * @function getIniV2: fetching the ini of the corresponding employee
   * @param employeeId : logged in employee id.
   *
   * @param callback
   */
  public async getIni(employeeId: string, callback) {
    if (db.open()) {
      db.transaction(
        'rw',
        db._INI,
        db.BidDataDisplay,
        db.ColumnDefinitions,
        async () => {
          await db._INI
            .where('userId')
            .equals(employeeId)
            .first()
            .then((iniObj) => {
              callback(iniObj);
            })
            .catch((error) => {
              callback(null);
            });
        }
      ).catch((err) => {
        callback(null);
      });
    }
  }

  public async getLatestNewsFileData(callBack) {
    if (db.open()) {
      await db
        .transaction('rw', db.LatestNews, async () => {
          await db.LatestNews.where('id')
            .equals(1)
            .first()
            .then((item) => {
              callBack(item);
            });
        })
        .then(() => {
          /**/
        })
        .catch((error) => {
          /**/
        });
    }
  }

  // public async getDataForViewFile(callBack) {
  //   if (db.open()) {
  //     await db.transaction('rw', db.WbidFiles, async () => {
  //       await db.WbidFiles.toArray().then((result) => {
  //         callBack(result);
  //       });
  //     });
  //   }
  // }
  public async getDataForViewFile(): Promise<any[]> {
    if (db.open()) {
      return db.transaction('rw', db.WbidFiles, () => db.WbidFiles.toArray());
    }
    return [];
  }
  public async getDataForCommuteDiffernce(callBack) {
    if (db.open()) {
      await db.transaction('rw', db.CommuteFltChange, async () => {
        await db.CommuteFltChange.toArray().then((result) => {
          callBack(result);
        });
      });
    }
  }
  public async getUserData(empId: string, callBack) {
    if (db.open()) {
      empId = empId.replace(/[^\d.]/g, '');
      await db
        .transaction('r', db.UserData, async () => {
          const userData = await db.UserData.where('empId')
            .equals(Number(empId))
            .first();
          callBack(userData);
        })
        .then(() => {
          /**/
        })
        .catch((error) => {
          throw `getQuickSetDataFor : ${error.stack}`;
        });
    }
  }

  public async getAllINI(callback) {
    //Need to call the INI according to the INI
    let itemToReturn;
    db.transaction(
      'rw',
      db._INI,
      db.BidDataDisplay,
      db.ColumnDefinitions,
      async () => {
        await db._INI
          .toArray()
          .then((item) => {
            itemToReturn = item;
          })
          .then(() => {
            callback(itemToReturn);
          });
      }
    );
  }

  public getFlightData = (bidType: string, fileName: string, callback) => {
    let flightData = null;
    try {
      if (db.open()) {
        db.transaction('rw', db.FlightDataMaster, () => {
          const record = db.FlightDataMaster.where('bidType')
            .notEqual('')
            .first();
          if (record) {
            db.FlightDataMaster.where('bidType')
              .equals(bidType)
              .first()
              .then((data) => {
                //callback(data)
                flightData = data;
              })
              .catch((error) => {
                callback(null);
              });
          }
        })
          .then(() => {
            // Transaction completed
            callback(flightData);
          })
          .catch((err) => {
            // transaction error
            callback(null);
          });
      }
    } catch {
      callback(null);
    }
  };

  public async syncUserData(data: any) {
    if (db.open()) {
      await db
        .transaction('rw', db.UserData, async () => {
          await db.UserData.where('empId')
            .equals(data.EmpNum)
            .first()
            .then(async (syncRecord) => {
              if (syncRecord) {
                db.UserData.where('empId').equals(data.EmpNum).modify({
                  IsAuthorized: data.IsAuthorized,
                  AuthRequestId: data.AuthRequestId,
                  Message: data.Message,
                  Type: data.Type,
                  ExpirationDate: data.ExpirationDate,
                  CBExpirationDate: data.CBExpirationDate,
                  WBExpirationDate: data.WBExpirationDate,
                  IsFree: data.IsFree,
                  IsYearlySubscribed: data.IsYearlySubscribed,
                  IsMonthlySubscribed: data.IsMonthlySubscribed,
                  TopSubscriptionLine: data.TopSubscriptionLine,
                  SecondSubscriptionLine: data.SecondSubscriptionLine,
                  ThirdSubscriptionLine: data.ThirdSubscriptionLine,
                  EmailId: data.EmailId,
                });
              } else {
                db.UserData.add({
                  empId: data.EmpNum,
                  IsAuthorized: data.IsAuthorized,
                  AuthRequestId: data.AuthRequestId,
                  Message: data.Message,
                  Type: data.Type,
                  ExpirationDate: data.ExpirationDate,
                  CBExpirationDate: data.CBExpirationDate,
                  WBExpirationDate: data.WBExpirationDate,
                  IsFree: data.IsFree,
                  IsYearlySubscribed: data.IsYearlySubscribed,
                  IsMonthlySubscribed: data.IsMonthlySubscribed,
                  TopSubscriptionLine: data.TopSubscriptionLine,
                  SecondSubscriptionLine: data.SecondSubscriptionLine,
                  ThirdSubscriptionLine: data.ThirdSubscriptionLine,
                  EmailId: data.EmailId,
                });
              }
            });
        })
        .catch((error) => {
          //Error
        });
    }
  }

  public async SyncColumnDefinitions(
    version: string,
    columnDefinitions: string
  ) {
    if (this.dbopen) {
      await db
        .transaction(
          'rw',
          db._INI,
          db.BidDataDisplay,
          db._Users,
          db.ColumnDefinitions,
          async () => {
            await db.ColumnDefinitions.where('version')
              .equals(version)
              .delete();
            db.ColumnDefinitions.add({
              version: version,
              columnDefinitionJsonString: columnDefinitions,
            })
              .then(() => {
                /**/
              })
              .catch(() => {
                /**/
              });
          }
        )
        .catch((error) => {
          //Error
        });
    }
  }

  public async UpdateorSaveUsers(id, callback) {
    if (!id || typeof id !== 'string') {
      callback(false);
      return;
    }
  
    localStorage.setItem('empnum', id);
    if (this.dbopen) {
      db.transaction(
        'rw',
        db._INI,
        db.BidDataDisplay,
        db._Users,
        db.ColumnDefinitions,
        async function () {
          const file = await db._Users.where('userid').equals(id).toArray();
          if (file.length > 0) {
            await db._Users
              .where('userid')
              .equals(id)
              .modify({ modified: Date.now() })
              .then(() => {
                callback(true);
              });
          } else {
            await db._Users
              .add({
                userid: id,
                modified: Date.now(),
              })
              .then(() => {
                callback(true);
              });
          }
        }
      )
        .catch(Dexie.ModifyError, function (e) {
          callback(false);
        })
        .catch(function (e) {
          callback(false);
          console.error('Generic error: ' + e);
        });
    }
  }

  // public async UpdateOrSaveWbidTxtFilesInDexie(Data: IBidDataFile) {
  //   if (this.dbopen) {
  //     db.transaction('rw', db.WbidFiles, async function () {
  //       const file = await db.WbidFiles.where('fileName')
  //         .equals(Data.FileName)
  //         .toArray();
  //       if (file.length > 0) {
  //         await db.WbidFiles.where('fileName')
  //           .equals(Data.FileName)
  //           .modify({ fileContent: Data.FileContent });
  //       } else {
  //         await db.WbidFiles.add({
  //           fileName: Data.FileName,
  //           fileContent: Data.FileContent,
  //         });
  //       }
  //     });
  //   }
  // }
    public async UpdateOrSaveWbidTxtFilesInDexie(Data: IBidDataFile, callBack?) {
    if (this.dbopen) {
      db.transaction("rw", db.WbidFiles, async function () {
        const file = await db.WbidFiles.where("fileName")
          .equals(Data.FileName)
          .toArray();
        if (file.length > 0) {
          await db.WbidFiles.where("fileName")
            .equals(Data.FileName)
            .modify({ fileContent: Data.FileContent })
            .then(() => {
              if (callBack) callBack(true);
            });
        } else {
          await db.WbidFiles.add({
            fileName: Data.FileName,
            fileContent: Data.FileContent,
          }).then(() => {
            if (callBack) callBack(true);
          });
        }
      });
    }
  }

  // public async UpdateOrSaveWbidTxtFilesInDexie(Data: IBidDataFile) {
  //   if (this.dbopen) {
  //     db.transaction('rw', db.WbidFiles, async function () {
  //       const file = await db.WbidFiles.where('fileName')
  //         .equals(Data.FileName)
  //         .toArray();
  //       if (file.length > 0) {
  //         await db.WbidFiles.where('fileName')
  //           .equals(Data.FileName)
  //           .modify({ fileContent: Data.FileContent });
  //       } else {
  //         await db.WbidFiles.add({
  //           fileName: Data.FileName,
  //           fileContent: Data.FileContent,
  //         });
  //       }
  //     });
  //   }
  // }
//   public async UpdateOrSaveWbidTxtFilesInDexie(data: IBidDataFile) {
//     if (!this.dbopen) return;

//   return db.transaction('rw', db.WbidFiles, async () => {
//     await db.WbidFiles.add({
//       fileName: data.FileName,
//       fileContent: data.FileContent
//       // createdAt: Date.now() // ensures uniqueness
//     });
//   });
// }
  public async UpdateOrSaveWbidPdfFilesInDexie(Data: pdfFile) {
    if (this.dbopen) {
      db.transaction('rw', db.WbidFiles, async function () {
        const file = await db.WbidFiles.where('fileName')
          .equals(Data.FileName)
          .toArray();
        if (file.length > 0) {
          await db.WbidFiles.where('fileName')
            .equals(Data.FileName)
            .modify({ fileContent: Data.FileContent });
        } else {
          await db.WbidFiles.add({
            fileName: Data.FileName,
            fileContent: Data.FileContent
          });
        }
      });
    }
  }
  public async clearWbidPdfFilesInDexie(): Promise<void> {
    await db.WbidFiles.clear(); // assuming your table is called wbidPdfFiles
  }
  public async SaveFileBasedOnType(fileName: string, content: string | Blob) {
    const isPdf = fileName.toLowerCase().endsWith('.pdf');
  
    if (isPdf) {
      await this.UpdateOrSaveWbidPdfFilesInDexie({
        FileName: fileName,
        FileContent: content as Blob,
      });
    } else {
      await this.UpdateOrSaveWbidTxtFilesInDexie({
        FileName: fileName,
        FileContent: content as string,
        IsError: false
      });
    }
  }
  public async SaveINI(data, callback) {
    if (this.dbopen) {
      const id = localStorage.getItem('empnum').replace(/[^\d.]/g, '');
      db.transaction(
        'rw',
        db._INI,
        db.BidDataDisplay,
        db._Users,
        db.ColumnDefinitions,
        async () => {
          const record = await db._INI.where('userId').equals(id).first();
          if (record == undefined) {
            await db._INI
              .add({
                fileid: '1',
                userId: id,
                compresseddata: JSON.stringify(data),
                modified: Date.now(),
                created: Date.now(),
                size: new TextEncoder().encode(data).length.toString(),
              })
              .then(() => {
                callback(true);
              });
          } else {
            // INI already exists
            callback(true);
          }
        }
      );
    }
  }

  public async syncEomVacationLines(
    combinationKey,
    bidData: TblBidDataDisplay,
    callback
  ) {
    if (this.dbopen) {
      await db
        .transaction(
          'rw',
          db._INI,
          db.BidDataDisplay,
          db._Users,
          db.ColumnDefinitions,
          async () => {
            const record = await db.BidDataDisplay.where('fileid')
              .equals(combinationKey)
              .and((x) => x.EmpNum == bidData.EmpNum)
              .toArray();

            const fileLines = await db.BidDataDisplay.where('lines')
              .notEqual('')
              .toArray();
            if (record.length > 0) {
              await db.BidDataDisplay.where('fileid')
                .equals(combinationKey)
                .and((x) => x.EmpNum == bidData.EmpNum)
                .modify({
                  vacationEomLines: bidData.vacationEomLines,
                  eomLines: bidData.eomLines,
                  modified: Date.now(),
                })
                .then(() => {
                  callback(true);
                });
            } else {
              await db.BidDataDisplay.add({
                Domicile: bidData.Domicile,
                Position: bidData.Position,
                Round: bidData.Round,
                Month: bidData.Month,
                Year: bidData.Year,
                lines: bidData.lines,
                trips: bidData.trips,
                state: bidData.state,
                vacationLines: bidData.vacationLines,
                vacationEomLines: bidData.vacationEomLines,
                eomLines: bidData.eomLines,
                fileid: combinationKey,
                modified: Date.now(),
                created: Date.now(),
                size: '',
                EmpNum: bidData.EmpNum,
              }).then((id) => {
                //Remove the Previous Downloaded Bid Data
                // db.BidDataDisplay.get()
                // alert(id);
                callback(true);
              });
            }
          }
        )
        .then(() => {
          /**/
        })
        .catch(Dexie.ModifyError, function (error) {
          callback(false);
          //  console.error(error.failures.length + " items failed to modify");
        });
    }
  }

  public async syncBidFiles(
    empId: number,
    key: string,
    bidFiles: any,
    callBack
  ) {
    if (this.dbopen) {
      db.transaction('rw', db.BidFileNames, async () => {
        const record = await db.BidFileNames.where('fieldId')
          .equals(key)
          .and((x) => x.empId == empId)
          .toArray();
        if (record.length > 0) {
          let existingData = cloneDeep(record[0].bidFiles);
          existingData = existingData.filter((x) => x.fileType !== 5);
          existingData = existingData.concat(...bidFiles);
          const uniqueArray = existingData.filter(
            (arr, index, self) =>
              index === self.findIndex((t) => t.fileType === arr.fileType)
          );
          await db.BidFileNames.where('fieldId')
            .equals(key)
            .and((x) => x.empId == empId)
            .modify({ bidFiles: uniqueArray })
            .then(() => {
              callBack(true);
            });
        } else {
          await db.BidFileNames.add({
            empId: empId,
            fieldId: key,
            bidFiles: bidFiles,
          }).then((id) => {
            callBack(true);
          });
        }
      })
        .then(() => {
          /**/
        })
        .catch(function (error) {
          callBack(false);
        });
    }
  }

  public async syncFAListData(empId: string, faListData: FAListData, callBack) {
    if (this.dbopen) {
      await db
        .transaction('rw', db.FAListData, async () => {
          const record = await db.FAListData.where('employeeId')
            .equals(empId)
            .toArray();
          if (record.length > 0) {
            await db.FAListData.where('employeeId')
              .equals(empId)
              .modify({ faList: faListData })
              .then(() => {
                callBack(true);
              });
          } else {
            await db.FAListData.add({
              employeeId: empId,
              faList: faListData,
            }).then((id) => {
              callBack(true);
            });
          }
        })
        .then(() => {
          /**/
        })
        .catch(function (error) {
          callBack(false);
        });
    }
  }

  public syncWbidFlightData = (
    flightDataLzStr: string,
    checkBid: string,
    fileName: string,
    flightdataVersionNumber: string,
    callback
  ) => {
    let isSaved = false;
    try {
      if (db.open()) {
        db.transaction('rw', db.FlightDataMaster, async () => {
          const record = await db.FlightDataMaster.where('bidType')
            .notEqual('')
            .first();
          if (record) {
            const data = await db.FlightDataMaster.where('bidType')
              .equals(checkBid)
              .first();
            if (data) {
              await db.FlightDataMaster.where('bidType')
                .equals(checkBid)
                .modify({
                  flightDataCompressedStr: flightDataLzStr,
                  flightDataName: fileName,
                  flightdataVersionNumber: flightdataVersionNumber,
                })
                .then(() => {
                  isSaved = true;
                })
                .catch((err) => {
                  // Error in adding the Flight Data
                  callback(false);
                });
            } else {
              await db.FlightDataMaster.add({
                flightDataCompressedStr: flightDataLzStr,
                flightDataName: fileName,
                bidType: checkBid,
                flightdataVersionNumber: flightdataVersionNumber,
              })
                .then(() => {
                  isSaved = true;
                })
                .catch((err) => {
                  // Error in adding the Flight Data
                  callback(false);
                });
            }
          } else {
            await db.FlightDataMaster.add({
              flightDataCompressedStr: flightDataLzStr,
              flightDataName: fileName,
              bidType: checkBid,
              flightdataVersionNumber: flightdataVersionNumber,
            })
              .then(() => {
                isSaved = true;
              })
              .catch((err) => {
                // Error in adding the Flight Data
                callback(false);
              });
          }
        })
          .then(() => {
            // Transaction completed successfully
            callback(isSaved);
          })
          .catch((tranError) => {
            // Error in transaction
            callback(false);
          });
      }
    } catch {
      callback(false);
    }
  };

  public async SyncStateFileModify(
    employeeNumber,
    key,
    stateFile: WBidStateCollection,
    callback
  ) {
    let status = false;
    if (db.open()) {
      await db
        .transaction('rw', db.BidDataDisplay, async () => {
          await db.BidDataDisplay.where('EmpNum')
            .equals(employeeNumber)
            .and((bid) => bid.fileid == key)
            .modify({ state: JSON.stringify(stateFile) })
            .then(() => {
              status = true;
            })
            .catch((error) => {
              status = false;
            });
        })
        .then(() => {
          callback(status);
        })
        .catch((err) => {
          callback(null);
        });
    }
  }

  public async SyncStateFile(stateFile: StateFiles, callback) {
    if (db.open()) {
      await db.transaction('rw', db.StateFiles, async () => {
        //need to update a check whether the state file exists or not

        const stateFileInDb = await db.StateFiles.where('stateKey')
          .equals(stateFile.stateKey)
          .toArray();
        if (stateFileInDb.length > 0) {
          await db.StateFiles.where('stateKey')
            .equals(stateFile.stateKey)
            .delete()
            .then(async (response) => {
              await db.StateFiles.add({
                stateKey: stateFile.stateKey,
                employeeId: stateFile.employeeId,
                bidId: stateFile.bidId,
                CompanyVA: stateFile.CompanyVA,
                DataSource: stateFile.DataSource,
                DefaultName: stateFile.DefaultName,
                StateList: stateFile.StateList,
                StateUpdatedTime: stateFile.StateUpdatedTime,
                SyncVersion: stateFile.SyncVersion,
                Vacation: stateFile.Vacation,
                Version: stateFile.Version,
                IsModified: stateFile.IsModified,
                FVVacation: stateFile.FVVacation,
                SeniorityListItem: stateFile.SeniorityListItem,
                BidAwards: stateFile.BidAwards,
              })
                .then((result) => {
                  callback(true);
                })
                .catch((error) => {
                  callback(false);
                  throw error.stack;
                });
            });
        } else {
          await db.StateFiles.add({
            stateKey: stateFile.stateKey,
            employeeId: stateFile.employeeId,
            bidId: stateFile.bidId,
            CompanyVA: stateFile.CompanyVA,
            DataSource: stateFile.DataSource,
            DefaultName: stateFile.DefaultName,
            StateList: stateFile.StateList,
            StateUpdatedTime: stateFile.StateUpdatedTime,
            SyncVersion: stateFile.SyncVersion,
            Vacation: stateFile.Vacation,
            Version: stateFile.Version,
            IsModified: stateFile.IsModified,
            FVVacation: stateFile.FVVacation,
            SeniorityListItem: stateFile.SeniorityListItem,
            BidAwards: stateFile.BidAwards,
          })
            .then((result) => {
              callback(true);
            })
            .catch((error) => {
              alert('error in saving state file');
              callback(false);
              throw error.stack;
            });
        }
      });
    }
  }

  public async DeleteDb(callback) {
    db.open().then(async (data) => {
      db.transaction(
        'rw',
        db._INI,
        db.BidDataDisplay,
        db._Users,
        db.ColumnDefinitions,
        async () => {
          await db
            .delete()
            .then(() => {
              callback(true);
              // alert("clear data done!.");
            })
            .catch(() => {
              callback(false);
            });
        }
      );
    });
  }

  public async SyncMonthlyBidData(
    combinationkey,
    bidData: TblBidDataDisplay,
    callback
  ) {
    if (this.dbopen) {
      await db
        .transaction(
          'rw',
          db._INI,
          db.BidDataDisplay,
          db._Users,
          db.ColumnDefinitions,
          db.LatestNews,
          async () => {
            const record = await db.BidDataDisplay.where('fileid')
              .equals(combinationkey)
              .and((x) => x.EmpNum == bidData.EmpNum)
              .toArray();
            // var fileLines = await db.BidDataDisplay.where('lines').notEqual('').toArray();
            if (record.length > 0) {
              await db.BidDataDisplay.where('fileid')
                .equals(combinationkey)
                .and((x) => x.EmpNum == bidData.EmpNum)
                .modify({
                  lines: bidData.lines,
                  vacationLines: bidData.vacationLines,
                  vacationEomLines: bidData.vacationEomLines,
                  eomLines: bidData.eomLines,
                  milLines: bidData.milLines,
                  trips: bidData.trips,
                  state: bidData.state,
                  BidPeriodEndDate: bidData.BidPeriodEndDate,
                  BidPeriodStartDate: bidData.BidPeriodStartDate,
                  modified: Date.now(),
                  isEBGUser: bidData.isEBGUser,
                  isHistoricalBid: bidData.isHistoricalBid,
                })
                .then(() => {
                  callback(true);
                });
            } else {
              await db.BidDataDisplay.add({
                Domicile: bidData.Domicile,
                Position: bidData.Position,
                Round: bidData.Round,
                Month: bidData.Month,
                Year: bidData.Year,
                lines: bidData.lines,
                trips: bidData.trips,
                state: bidData.state,
                vacationLines: bidData.vacationLines,
                vacationEomLines: bidData.vacationEomLines,
                eomLines: bidData.eomLines,
                milLines: bidData.milLines,
                fileid: combinationkey,
                modified: Date.now(),
                created: Date.now(),
                size: '',
                EmpNum: bidData.EmpNum,
                BidPeriodEndDate: bidData.BidPeriodEndDate,
                BidPeriodStartDate: bidData.BidPeriodStartDate,
                isEBGUser: bidData.isEBGUser,
                isHistoricalBid: bidData.isHistoricalBid,
              }).then((id) => {
                //Remove the Previous Downloaded Bid Data
                // db.BidDataDisplay.get()
                // alert(id);
                callback(true);
              });
            }
          }
        )
        .then(() => {
          /**/
        })
        .catch(Dexie.ModifyError, function (error) {
          callback(false);
          //  console.error(error.failures.length + " items failed to modify");
        });
      // .catch (function (e) {

      //   callback(false);
      //   console.error("Generic error: " + e);

      // });
    }
  }
  public async DeleteLinePrevOperation(callback) {
    db.transaction(
      'rw',
      db._INI,
      db.BidDataDisplay,
      db._Users,
      db.ColumnDefinitions,
      async () => {
        const CurrentBidPeriod = moment().add(1, 'months').format('MM');
        let Bida = await db.BidDataDisplay.where('modified')
          .notEqual('')
          .toArray();
        Bida = _.filter(Bida, (item) => item.lines !== '');
        Bida = _.filter(Bida, (item) => item.lines !== undefined);
        if (Bida.length > 2) {
          let elementSortedbymodified: TblBidDataDisplay[] = _.sortBy(
            Bida,
            'modified'
          );
          elementSortedbymodified = elementSortedbymodified.reverse();
          if (
            elementSortedbymodified[1].Month ==
            Number.parseInt(CurrentBidPeriod)
          ) {
            //delete elementSortedbyID[2]
            const Fileid = elementSortedbymodified[2].fileid;
            this.RemoveBidDataLine(Fileid, (isdeleted) => {
              callback('Deleted..' + Fileid);
            });
          } else {
            //delete elementSortedbymodified[1] data
            const Fileid = elementSortedbymodified[1].fileid;
            this.RemoveBidDataLine(Fileid, (isdeleted) => {
              callback('Deleted..' + Fileid);
            });
          }
        } else {
          callback('Deleted Nothing');
        }
      }
    );
  }

  public async deleteBidData(id: string, callback) {
    if (this.dbopen) {
      db.transaction(
        'rw',
        db._INI,
        db.BidDataDisplay,
        db._Users,
        db.ColumnDefinitions,
        async () => {
          await db.BidDataDisplay.where('fileid')
            .equals(id)
            .delete()
            .then(() => {
              callback(true);
            });
        }
      );
    }
  }
  public async deleteCommuteDifferenceData(filename: string, callback) {
    if (this.dbopen) {
      db.transaction('rw', db.CommuteFltChange, async () => {
        await db.CommuteFltChange.where('fileName')
          .equals(filename)
          .delete()
          .then(() => {
            callback(true);
          });
      });
    }
  }
  public async updateINI(data, callback) {
    //update the last updated time.
    const date = this.helper.getISOStringWithoutSecsAndMillisecs1(new Date());
    data.LastUpdateTime = date;
    if (this.dbopen) {
      const userId = localStorage.getItem('empnum').replace(/[^\d.]/g, '');
      db.transaction(
        'rw',
        db._INI,
        db.BidDataDisplay,
        db._Users,
        db.ColumnDefinitions,
        async () => {
          await db._INI
            .where('userId')
            .equals(userId)
            .modify({
              compresseddata: JSON.stringify(data),
              modified: Date.now(),
            })
            .then(() => {
              callback(true);
            })
            .catch(() => {
              callback(false);
            });
        }
      );
    }
  }

  public async UpdateOrSaveLatestNews(Data: SubmitResult, callback) {
    if (this.dbopen) {
      db.transaction('rw', db.LatestNews, async function () {
        const file = await db.LatestNews.toArray();
        if (file.length > 0) db.LatestNews.clear();
        await db.LatestNews.add({
          id: 1,
          latestNewsContent: Data.Result,
        }).then(() => {
          callback();
        });
      });
    }
  }

  public async RemoveBidDataLine(id: string, callback) {
    if (this.dbopen) {
      db.transaction(
        'rw',
        db._INI,
        db.BidDataDisplay,
        db._Users,
        db.ColumnDefinitions,
        async () => {
          await db.BidDataDisplay.where('fileid')
            .equals(id)
            .modify({ lines: '' })
            .then(() => {
              callback(true);
            });
        }
      );
    }
  }

  public getCurrentBidData(employeeNumber, key, callback) {
    let bidToReturn = null;
    if (db.open()) {
      db.transaction(
        'rw',
        db._INI,
        db.BidDataDisplay,
        db.ColumnDefinitions,
        db._INI,
        async () => {
          db.BidDataDisplay.where('EmpNum')
            .equals(employeeNumber)
            .and((bid) => bid.fileid == key)
            .first()
            .then((bid) => {
              bidToReturn = bid;
              //callback(bid);
            })
            .catch((error) => {
              callback(bidToReturn);
            });
        }
      )
        .then(() => {
          callback(bidToReturn);
        })
        .catch((err) => {
          callback(bidToReturn);
        })
        .finally(() => {
          /* */
        });
    }
  }

  public async GetUser(id, callback) {
    if (this.dbopen) {
      db.transaction(
        'rw',
        db._INI,
        db.BidDataDisplay,
        db._Users,
        db.ColumnDefinitions,
        async () => {
          callback(await db._Users.where('userid').equals(id).toArray());
        }
      );
    }
  }

  public async GetColumnDefinition(callback) {
    if (this.dbopen) {
      db.transaction(
        'rw',
        db._INI,
        db.BidDataDisplay,
        db.ColumnDefinitions,
        async () => {
          await db.ColumnDefinitions.where('version')
            .notEqual('')
            .first()
            .then((colDef) => {
              callback(colDef);
            })
            .catch((err) => {
              callback(null);
            });
        }
      ).catch((error) => {
        callback(null);
      });
    }
  }

  public async SyncStateFileV2(
    employeeNumber,
    key,
    stateFile: WBidStateCollection,
    callback
  ) {
    let status = false;
    if (db.open()) {
      await db
        .transaction('rw', db.BidDataDisplay, async () => {
          await db.BidDataDisplay.where('EmpNum')
            .equals(employeeNumber)
            .and((bid) => bid.fileid == key)
            .modify({ state: JSON.stringify(stateFile) })
            .then(() => {
              status = true;
            })
            .catch((error) => {
              status = false;
            });
        })
        .then(() => {
          callback(status);
        })
        .catch((err) => {
          callback(null);
        });
    }
  }
  public async SyncQuickSet(
    empid: number,
    quickSetData: QuickSets,
    quickSetCSWName: string,
    selectionType: string,
    callback
  ) {
    if (db.open()) {
      let name;
      selectionType == 'QuickSetCSW'
        ? (name = 'QuickSetCSWName')
        : (name = 'QuickSetColumnName');
      await db
        .transaction('rw', db.QuickSet, async () => {
          var quicksetData = await db.QuickSet.where('empId')
            .equals(empid)
            .and((x) =>
              JSON.parse(x.quickSetData)[
                `${selectionType.replace(`"`, '')}`
              ].find((obj) => obj[name] == quickSetCSWName)
            )
            .first()
            .then(async (result) => {
              if (result)
                callback(
                  false,
                  'Name already exist. Please choose another Name.'
                );
              else {
                if (quicksetData == undefined || quickSetData == null) {
                  await db.QuickSet.add({
                    empId: empid,
                    quickSetData: JSON.stringify(quickSetData),
                  }).then(() => {
                    callback(true);
                  });
                }
              }
            });
        })
        .catch((error) => {
          throw error.stack;
          callback(false);
        });
    }
  }

  public async deleteQuickSetDataFor(
    empid: number,
    selectionType: string,
    selectedName: string,
    callback
  ) {
    if (db.open()) {
      let name;
      selectionType == 'QuickSetCSW'
        ? (name = 'QuickSetCSWName')
        : (name = 'QuickSetColumnName');
      await db.transaction('rw', db.QuickSet, async () => {
        const quicksetData = await db.QuickSet.where('empId')
          .equals(empid)
          .and((x) =>
            JSON.parse(x.quickSetData)[
              `${selectionType.replace(`"`, '')}`
            ].find((obj) => obj[name] == selectedName)
          )
          .first();
        const quickSetID = quicksetData.id;
        await db.QuickSet.where('id')
          .equals(quickSetID)
          .delete()
          .then(async () => {
            const updateData = JSON.parse(quicksetData.quickSetData);
            updateData[`${selectionType.replace(`"`, '')}`] = [];
            await db.QuickSet.add({
              empId: empid,
              quickSetData: JSON.stringify(updateData),
            }).then(() => {
              callback(true);
            });
          });
      });
    }
  }

  public getMonthlyBidData = (employeeNumber, key, callback) => {
    let bidToReturn = null;
    if (db.open()) {
      db.transaction(
        'rw',
        db._INI,
        db.BidDataDisplay,
        db.ColumnDefinitions,
        db._INI,
        async () => {
          db.BidDataDisplay.where('EmpNum')
            .equals(employeeNumber)
            .and((bid) => bid.fileid == key)
            .first()
            .then((bid) => {
              bidToReturn = bid;
              //callback(bid);
            })
            .catch((error) => {
              callback(bidToReturn);
            });
        }
      )
        .then(() => {
          callback(bidToReturn);
        })
        .catch((err) => {
          callback(bidToReturn);
        })
        .finally(() => {
          /**/
        });
    }
  };

  public async getBidFiles(empId: number, key: string, callBack) {
    if (this.dbopen) {
      db.transaction('r', db.BidFileNames, async () => {
        const recordToReturn = await db.BidFileNames.where('fieldId')
          .equals(key)
          .and((x) => x.empId == empId)
          .first();
        if (recordToReturn !== undefined) {
          callBack(recordToReturn);
        } else {
          callBack(null);
        }
      });
    }
  }

  public async getFAList(employeeId: string, callBack) {
    if (this.dbopen) {
      db.transaction('r', db.FAListData, async () => {
        const recordToReturn = await db.FAListData.where('employeeId')
          .equals(employeeId)
          .first();
        if (recordToReturn !== undefined) {
          callBack(recordToReturn);
        } else {
          callBack(null);
        }
      });
    }
  }

  public async getStateQuickSetVersionInfo(
    empId: number,
    key: string,
    callback
  ) {
    if (db.open()) {
      await db
        .transaction('r', db.StateQuickSetVersionInfo, async () => {
          const versionData = await db.StateQuickSetVersionInfo.where('empId')
            .equals(empId)
            .and((versionInfo) => versionInfo.fileid == key)
            .first();
          callback(versionData);
        })
        .then(() => {
          /**/
        })
        .catch((error) => {
          throw `getStateQuickSetVersionInfo : ${error.stack}`;
        });
    }
  }

  public async SyncQuickkSetFromServer(empid: number, quickSetData: QuickSets) {
    if (db.open()) {
      let item = {};
      await db.QuickSet.clear()
        .then(async () => {
          for (let i = 0; i < quickSetData.QuickSetCSW.length; i++) {
            item = {
              QuickSetCSW: [quickSetData.QuickSetCSW[i]],
              QuickSetColumn: [],
            };
            await db.QuickSet.add({
              empId: empid,
              quickSetData: JSON.stringify(item),
            });
          }
        })
        .then(async () => {
          for (let i = 0; i < quickSetData.QuickSetColumn.length; i++) {
            item = {
              QuickSetCSW: [],
              QuickSetColumn: [quickSetData.QuickSetColumn[i]],
            };
            await db.QuickSet.add({
              empId: empid,
              quickSetData: JSON.stringify(item),
            });
          }
        });
    }
  }

  public async SyncStateQuickSetVersionInfo(
    empId: number,
    key: string,
    serverData: any,
    fileType: number,
    callBack
  ) {
    if (db.open()) {
      await db
        .transaction('rw', db.StateQuickSetVersionInfo, async () => {
          await db.StateQuickSetVersionInfo.where('empId')
            .equals(empId)
            .and((versionInfo) => versionInfo.fileid == key)
            .first()
            .then(async (syncRecord) => {
              if (syncRecord) {
                await db.StateQuickSetVersionInfo.where('empId')
                  .equals(empId)
                  .and((versionInfo) => versionInfo.fileid == key)
                  .modify({
                    quickSetVersion: serverData.QuickSetVersionNumber,
                    stateVersion: serverData.VersionNumber,
                    quickSetLastUpdatedTime: serverData.QuickSetLastUpdatedTime,
                    stateLastUpdatedTime: serverData.LastUpdatedTime,
                    isStateModified: serverData.IsStateModified,
                    isQuickSetModified: serverData.IsQuickSetModified,
                  })
                  .then(() => {
                    callBack(true);
                  });
              } else {
                await db.StateQuickSetVersionInfo.add({
                  empId: empId,
                  quickSetVersion: serverData.QuickSetVersionNumber,
                  stateVersion: serverData.VersionNumber,
                  quickSetLastUpdatedTime: serverData.QuickSetLastUpdatedTime,
                  stateLastUpdatedTime: serverData.LastUpdatedTime,
                  isStateModified: serverData.IsStateModified,
                  isQuickSetModified: serverData.IsQuickSetModified,
                  fileid: key,
                }).then(() => {
                  callBack(true);
                });
              }
            });
        })
        .catch((error) => {
          callBack(false);
        });
    }
  }

  public async getQuickSetDataFor(
    empid: number,
    selectionType: string,
    callback
  ) {
    if (db.open()) {
      await db
        .transaction('r', db.QuickSet, async () => {
          const quicksetData = await db.QuickSet.where('empId')
            .equals(Number(empid))
            .toArray();
          callback(quicksetData);
        })
        .then(() => {
          /**/
        })
        .catch((error) => {
          throw `getQuickSetDataFor : ${error.stack}`;
        });
    }
  }

  public async syncBidReceipt(
    employeeID: string,
    bidReceipt: string,
    callBack
  ) {
    if (this.dbopen) {
      await db
        .transaction('rw', db.UserBidReceipt, async () => {
          const record = await db.UserBidReceipt.where('employeeId')
            .equals(employeeID)
            .toArray();

          if (record.length > 0) {
            await db.UserBidReceipt.where('employeeId')
              .equals(employeeID)
              .modify({ bidReceipt: bidReceipt })
              .then(() => {
                callBack(true);
              });
          } else {
            await db.UserBidReceipt.add({
              employeeId: employeeID,
              bidReceipt: bidReceipt,
            }).then((id) => {
              callBack(true);
            });
          }
        })
        .then(() => {
          /**/
        })
        .catch(Dexie.ModifyError, function (error) {
          callBack(false);
        });
    }
  }

  public async getBidReceipt(employeeId: string, callBack) {
    if (this.dbopen) {
      db.transaction('rw', db.UserBidReceipt, async () => {
        const recordToReturn = await db.UserBidReceipt.where('employeeId')
          .equals(employeeId)
          .first();
        if (recordToReturn !== undefined) {
          callBack(recordToReturn);
        } else {
          callBack(null);
        }
      });
    }
  }
  /**
   * @method syncCommuteDiffernceDataInDexie for inserting or updating the txt files
   * @param Data is bid txt file content
   * @param callBack for response
   */
  public async syncCommuteDiffernceDataInDexie(Data: IBidDataFile, callBack?) {
    if (this.dbopen) {
      db.transaction('rw', db.CommuteFltChange, async function () {
        const file = await db.CommuteFltChange.where('fileName')
          .equals(Data.FileName)
          .toArray();
        if (file.length > 0) {
          await db.CommuteFltChange.where('fileName')
            .equals(Data.FileName)
            .modify({ fileContent: Data.FileContent })
            .then(() => {
              if (callBack) callBack(true);
            });
        } else {
          await db.CommuteFltChange.add({
            fileName: Data.FileName,
            fileContent: Data.FileContent,
          }).then(() => {
            if (callBack) callBack(true);
          });
        }
      });
    }
  }

  /**
   * @method setBideditorStringInDexie for inserting or updating the txt files
   * @param Data is bid Choice file content
   * @param callBack for response
   */
  public async setBideditorStringInDexie(Data: IBidDataFile, callBack?) {
    if (this.dbopen) {
      db.transaction('rw', db.bidEditorChoice, async function () {
        const file = await db.bidEditorChoice
          .where('fileName')
          .equals(Data.FileName)
          .toArray();
        if (file.length > 0) {
          await db.bidEditorChoice
            .where('fileName')
            .equals(Data.FileName)
            .modify({ fileContent: Data.FileContent })
            .then(() => {
              if (callBack) callBack(true);
            });
        } else {
          await db.bidEditorChoice
            .add({
              fileName: Data.FileName,
              fileContent: Data.FileContent,
            })
            .then(() => {
              if (callBack) callBack(true);
            });
        }
      });
    }
  }

  public async getDataForBideditorString(callBack) {
    if (db.open()) {
      await db.transaction('rw', db.bidEditorChoice, async () => {
        await db.bidEditorChoice.toArray().then((result) => {
          callBack(result);
        });
      });
    }
  }

  public async deleteBidEditorString(filename: string, callback) {
    if (this.dbopen) {
      db.transaction('rw', db.bidEditorChoice, async () => {
        await db.bidEditorChoice
          .where('fileName')
          .equals(filename)
          .delete()
          .then(() => {
            callback(true);
          });
      });
    }
  }
}
